import { atom } from 'nanostores';

import type { ProposedAction } from '@/entities/proposed-actions';
import type { SourceProposedActionT } from '@/shared/lib';

export interface DosespotActionPrefill {
  action: ProposedAction;
  sourceProposedAction?: SourceProposedActionT;
}

export const $dosespotActionPrefill = atom<DosespotActionPrefill | null>(null);

export function setDosespotActionPrefill(prefill: DosespotActionPrefill) {
  $dosespotActionPrefill.set(prefill);
}

export function clearDosespotActionPrefill() {
  $dosespotActionPrefill.set(null);
}
